import { useQuery } from '@tanstack/react-query';
import { supabase } from '@/lib/supabase';

/**
 * usePayments — the current customer's payment history (RLS-scoped to their own
 * payments via orders.payments.pay_select_own). Each row carries the invoices
 * it was applied to. This is the customer's saved receipt record.
 */
export interface PaymentAllocation {
  qbo_invoice_id: string;
  amount: number | string;
}
export interface PaymentRow {
  id: string;
  amount: number | string;
  status: string;
  type: string | null;
  processor: string | null;
  initiated_by: string | null;
  created_at: string;
  stripe_payment_intent_id: string | null;
  payment_invoice_allocations: PaymentAllocation[];
}

export function usePayments() {
  return useQuery<PaymentRow[]>({
    queryKey: ['payments-history'],
    queryFn: async () => {
      const { data, error } = await supabase
        .schema('orders')
        .from('payments')
        .select(
          'id,amount,status,type,processor,initiated_by,created_at,stripe_payment_intent_id,' +
            'payment_invoice_allocations(qbo_invoice_id,amount)',
        )
        .order('created_at', { ascending: false })
        .limit(200);
      if (error) throw error;
      return (data ?? []) as unknown as PaymentRow[];
    },
    staleTime: 30_000,
  });
}
